import type { PROGRAMMING_KINDS } from './kind'

/** Valores emitidos por `Programming#kind` na api (enum do Rails). */
export type ProgrammingKind = (typeof PROGRAMMING_KINDS)[number]['slug']

/** Posição da sessão em relação ao instante atual. */
export type TemporalStatus = 'live' | 'future' | 'past'

export type SessionSpeaker = {
  id?: number
  name?: string | null
  photo?: { file?: { url?: string | null } | null } | null
}

export type SessionPlace = {
  id?: number
  name?: string | null
}

/**
 * Sessão da programação, conforme `Programming::UserSerializer`.
 * Campos opcionais refletem o que o serializer pode omitir ou enviar nulo.
 */
export type Session = {
  id: number
  name?: string | null
  description?: string | null
  kind?: string | null
  start_at: string
  end_at: string
  place?: SessionPlace | null
  speakers?: SessionSpeaker[] | null
  tag_list?: string[] | null
  has_rewards?: boolean
  checkin_active?: boolean
  point_reward?: number
  coin_reward?: number
  finished?: boolean
  reactions?: Record<string, number>
  my_reactions?: string[] | null
  presentation_link?: string | null
}

/** Sessões agrupadas por data ISO (`YYYY-MM-DD`), ordenadas cronologicamente. */
export type ScheduleDayMap = Record<string, Session[]>

/** Identificador do chip de filtro por momento (ordem = prioridade na UI). */
export type ScheduleTimeFilter =
  | 'agora'
  | 'proximas'
  | 'meu-checkin'
  | 'passadas'

/** Prioridade de abertura e ordem dos chips — encerradas por último. */
export const SCHEDULE_TIME_FILTER_PRIORITY: ScheduleTimeFilter[] = [
  'agora',
  'proximas',
  'meu-checkin',
  'passadas'
]

/** Abre em "Acontecendo"; se não houver ao vivo, cai na primeira pill visível. */
export const DEFAULT_SCHEDULE_TIME_FILTER: ScheduleTimeFilter = 'agora'

export function pickScheduleTimeFilter(
  preferred: ScheduleTimeFilter,
  visible: ScheduleTimeFilter[]
): ScheduleTimeFilter {
  if (visible.includes(preferred)) return preferred
  return (
    SCHEDULE_TIME_FILTER_PRIORITY.find(id => visible.includes(id)) ?? 'passadas'
  )
}

/** Estado dos filtros avançados (popover). Cada campo `null` = sem filtro ativo. */
export type AdvancedFilters = {
  place?: string | null
  speaker?: number | null
  kind?: string | null
}
